import { render, staticRenderFns } from "./historyDetail.vue?vue&type=template&id=c05d0e4e"
import script from "./historyDetail.vue?vue&type=script&lang=js"
export * from "./historyDetail.vue?vue&type=script&lang=js"
import style0 from "./historyDetail.vue?vue&type=style&index=0&id=c05d0e4e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports